import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TwoFactorError, TwoFactorSelect } from '@ibk/shared-auth';
import { TranslationProvider } from '@ibk/shared-translation';
import { Card, Icon, Loading } from '@ibk/shared-ui';
import { dominioempresaTranslations } from '../../translations';
import styles from './TwoFactorSelect.module.css';
import { useTwoFactorSelect } from './useTwoFactorSelect';
function TwoFactorSelectContent({ bpo }) {
    const { options, setSelected, loading, error, setError, hasAccessLoading, handleContinue, handleBack } = useTwoFactorSelect();
    const renderContent = () => {
        if (hasAccessLoading) {
            return (_jsx("div", { className: styles.loadingContainer, children: _jsx(Loading, { size: 'medium' }) }));
        }
        if (options.length === 0) {
            return _jsx(TwoFactorError, { onButtonClick: handleBack });
        }
        return (_jsx(TwoFactorSelect, { options: options.map(opt => ({ ...opt, icon: _jsx(Icon, { name: opt.icon }) })), onSelect: setSelected, onContinue: handleContinue, onBack: handleBack, loading: loading, error: error, onErrorClose: () => setError(null), theme: {
                primaryColor: '#d64000',
            } }));
    };
    return (_jsx("main", { className: bpo ? styles.bpoContainer : styles.container, children: _jsx(Card, { padding: 36, borderRadius: 8, style: bpo ? undefined : { maxWidth: 340, width: '100%' }, className: bpo ? styles.bpoCard : styles.card, children: renderContent() }) }));
}
export default function TwoFactorSelectPage({ bpo = false }) {
    return (_jsx(TranslationProvider, { translations: dominioempresaTranslations, defaultLanguage: 'pt-BR', children: _jsx(TwoFactorSelectContent, { bpo: bpo }) }));
}
